module.exports = __webpack_public_path__ + "img/video-icon.ad06334f.svg";